import { useContent } from "@/content";

export const Marquee = () => {
  const { MARQUEE_ITEMS } = useContent();
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="relative border-y border-slate-200 bg-white py-5 overflow-hidden" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {[...row, ...row].map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-mono text-sm tracking-[0.3em] text-slate-500 uppercase">{item}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-amber-400 shadow-[0_0_10px_rgba(255,159,28,0.6)]" />
          </span>
        ))}
      </div>
    </div>
  );
};
